import { useState } from "react";
import { TeamsFrame } from "./TeamsFrame";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useRefonte } from "../translations/refonte";

const AltitudesSection = () => {
  const { language } = useLanguage();
  const a = useRefonte(language).altitudes;
  const [active, setActive] = useState(0);
  const item = a.items[active];
  const slides = a.items.map((it) => ({ img: it.img, title: it.caption, text: it.text }));

  return (
    <section className="bg-surfacec-50 py-20 lg:py-24 border-y border-linec-300/60" data-testid="altitudes-section">
      <div className="wrap-cayus">
        <div className="max-w-2xl mb-10">
          <div className="rule-cobalt mb-5" />
          <p className="mono-cayus text-cobalt-600 mb-4">{a.eyebrow}</p>
          <h2 className="font-bold text-3xl sm:text-4xl text-inkc-800 tracking-[-0.025em] mb-4">{a.title}</h2>
          <p className="text-lg text-inkc-600">{a.lead}</p>
        </div>

        {/* Contrôle segmenté */}
        <div className="inline-flex flex-wrap p-1 bg-white border border-linec-300 rounded-lg mb-10 gap-1">
          {a.items.map((alt, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`px-4 py-2 rounded-md text-sm font-semibold transition-colors ${
                i === active
                  ? "bg-cobalt-600 text-white shadow-[inset_0_-2px_0_0_#5EB3F6]"
                  : "text-inkc-600 hover:bg-cobalt-50 hover:text-cobalt-700"
              }`}
              data-testid={`altitude-tab-${i}`}
            >
              {alt.tab}
            </button>
          ))}
        </div>

        <div className="grid lg:grid-cols-[1.35fr_1fr] gap-10 lg:gap-14 items-start">
          <TeamsFrame src={item.img} alt={item.caption} caption={item.caption} slides={slides} slideIndex={active} />
          <div>
            <p className="text-lg text-inkc-700 mb-7">{item.text}</p>
            <div className="border-l-[3px] border-[#10B981] bg-[#D1FAE5]/40 rounded-r-lg px-4 py-3.5">
              <p className="mono-cayus text-[#047857] mb-1.5 flex items-center gap-1.5">
                <ShieldCheck className="w-3.5 h-3.5" />
                {a.guaranteeLabel}
              </p>
              <p className="text-sm text-inkc-700">{item.guarantee}</p>
            </div>
            <a
              href={item.href}
              className="mt-7 inline-flex items-center gap-1.5 text-sm font-semibold text-cobalt-600 hover:text-cobalt-700 group"
              data-testid="altitude-detail-link"
            >
              {a.linkPrefix} {item.tab}
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AltitudesSection;
